import { Modal, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import '../../../assets/styles/RM.css'
import '../../../assets/styles/Inventory.css'
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import { useKYCContext } from '../../../services/contexts/KYCContext';
import { useCRMContext } from '../../../services/contexts/CRMContext';
import { useRMContext } from '../../../services/contexts/RMContext';
import { useCMContext } from '../../../services/contexts/companyManagement/CMContext';
import { uploadUserInsightBulk } from '../../../services/apis/CRMApi';

export default function CreateEntryPage() {

    const { setShowSuccess, token, logout, setLoginError } = useLogin()
    const { editRemark, setEditRemark, editRemarkData, setEditRemarkData, createEditRemark, getAllLatestRemarkList, getAllRemarkListByUser, remarkList, remarkListType, setRemarkListType, getRemarkByRemarkType, setCustomer, customer, setRelationshipManager, relationshipManager } = useCRMContext()
    const { getKYCVerifiedCustomer, kycVerifiedList } = useKYCContext()
    const { companyList, getAllCompaniesList } = useCMContext()
    const { adminList } = useRMContext()

    const [lastCallDate, setLastCallDate] = useState("")
    const [remark, setRemark] = useState("")
    const [comapnyId, setCompanyId] = useState("")
    const [custSegment, setCustSegment] = useState("")
    const [followUpDate, setFollowUpDate] = useState("")
    const [interested_in, setInterested_in] = useState("0")
    const [error, setError] = useState("")
    const [file, setFile] = useState("")
    const [fileError, setFileError] = useState("")
    const [errorDetail, setErrorDetail] = useState("")
    const [showErrorModal, setShowErrorModal] = useState(false)

    const history = useHistory()

    const handleClose = () => {
        setShowErrorModal(false);
    };

    useEffect(() => {
        try {
            getAllCompaniesList()
            if (editRemarkData && editRemarkData.user) {
                setCustomer(editRemarkData && editRemarkData.user ? editRemarkData.user : "")
                setRelationshipManager(editRemarkData.relationship_manager && editRemarkData.relationship_manager.name ? editRemarkData.relationship_manager : "")
                setCompanyId(editRemarkData && editRemarkData.company ? editRemarkData.company : "")
                setCustSegment(editRemarkData && editRemarkData.cx_segment ? editRemarkData.cx_segment : "")
                setFollowUpDate(editRemarkData && editRemarkData.follow_up_date ? editRemarkData.follow_up_date : "")
                setInterested_in(editRemarkData && editRemarkData.interested_in ? editRemarkData.interested_in : "")
                setError("")
            }
        } catch (error) {
            console.error(error)
        }
    }, [editRemarkData])


    const handleCustomerChange = async (e, value) => {
        try {
            setCustomer(value)
            value ? getRemarkByRemarkType(Object.keys(configs.crm_insights)[2], true, configs.recordPerPage, value, remarkListType === Object.keys(configs.crm_insights)[2]) : setRelationshipManager({})
        } catch (error) {
            console.error(error);
        }
    }

    const handleRMChange = (e, value) => {
        try {
            setRelationshipManager(value)
            if (remarkListType === Object.keys(configs.crm_insights)[3])
                getRemarkByRemarkType(Object.keys(configs.crm_insights)[3], true, configs.recordPerPage, value)
        } catch (error) {

        }
    }

    const handleCompanyChange = (e, value) => {
        try {
            setCompanyId(value)
        } catch (error) {

        }
    }


    // add company function
    async function addRemark() {
        try {

            document.getElementById("newsBtn").classList.toggle("d-none")
            document.getElementById("newsBtnLoader").classList.toggle("d-none")

            // if (!editRemark && !company) {
            //     setError("Please select a valid company.")
            // } else if (!heading || (heading && heading.length > 500)) {
            //     setError("Please provide a valid heading.")
            // } else if (!description) {
            //     setError("Please provide a valid description.")
            // } else if (!link) {
            //     setError("Please provide a valid link.")
            // } else if (!date) {
            //     setError("Please provide a valid date.")
            // } else if (!image) {
            //     setError("Please provide a valid image URL.")
            // } else {
            let response = await createEditRemark(customer.id, new Date().toISOString().split('T')[0], remark, comapnyId.id, custSegment, followUpDate, interested_in, relationshipManager.id)

            if (response && response === "success") {
                resetValues()
                setShowSuccess(true)
                getRemarkByRemarkType(remarkListType, true, configs.allRecordsFetchedTillNow)
                // setRemarkListType("latest")
            } else {
                setError(response)
            }
            // }

            document.getElementById("newsBtn").classList.toggle("d-none")
            document.getElementById("newsBtnLoader").classList.toggle("d-none")
        } catch (error) {
            console.error(error);
        }
    }

    // get file contents through file chooser
    function uploadFile(file) {
        try {
            if (file && (file.type === ".csv" || file.type === "text/csv" || file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type === "application/vnd.ms-excel" || (file.name && file.name.toLowerCase().endsWith(".csv")))) {
                setFile(file)
                setFileError("")
            } else {
                alert("Only csv files are allowed.")
            }
        } catch (error) {
            console.error(error)
        }
    }

    // upload csv to server
    async function uploadFileToServer() {
        try {
            if (file) {
                document.getElementById("crmBulkBtn").classList.toggle("d-none")
                document.getElementById("crmBulkBtnLoader").classList.toggle("d-none")

                let response = await uploadUserInsightBulk(token, file);
                if (response && response.status === 200) {
                    setFileError("")
                    setFile("")
                    setErrorDetail("")
                    setShowSuccess(true)
                    getRemarkByRemarkType(remarkListType, true, configs.allRecordsFetchedTillNow)
                } else if (response && response.status === 401) {
                    logout();
                    setLoginError(configs.unauthorizedErrorMessage);
                }
                else if (response && response.status === 406) {
                    setFileError("Click to view error details.");
                    setErrorDetail(response.data.error);
                }
                else {
                    setFileError(response.data.error)
                }


            } else {
                setFileError("Please select a file to upload.")
            }
        } catch (error) {
            console.error(error)
        } finally {
            document.getElementById("crmBulkBtn").classList.toggle("d-none")
            document.getElementById("crmBulkBtnLoader").classList.toggle("d-none")
        }
    }

    // reset all values
    function resetValues() {
        try {
            // setCustomer({})
            // setRelationshipManager({})
            setLastCallDate("")
            setRemark("")
            setCompanyId("")
            setCustSegment("")
            setFollowUpDate("")
            setInterested_in("")
            setError("")
            setEditRemarkData({})
            getRemarkByRemarkType(remarkListType, true, null)
        } catch (error) {

        }
    }

    // create role ui code
    return (
        <div id="rmCreateNews" className="col-lg-3 col-md-4 d-md-block d-none pt-3 main-rmPanel">
            <p className="h6 text-custom-grey">{editRemark ? "Edit Remark Information" : "Add a Remark or Manager"}</p>
            <form id="createRoleForm" action="" className='mr-1'>
                {!editRemark ? <div className="form-group">
                    <label className="f-12">Customer</label>
                    {kycVerifiedList ? <Autocomplete
                        className="f-12"
                        id="companyIP"
                        value={customer}
                        placeholder="Customer Name"
                        getOptionLabel={option => option && option.email ? `${option.name} - ${option.email}` : ""}
                        onChange={handleCustomerChange}
                        options={kycVerifiedList}
                        renderInput={(params) => <TextField {...params} placeholder="Customer Name" className="f-12" onChange={getKYCVerifiedCustomer} />}
                    /> : null}
                </div> : <div>
                    <label className="f-12">Customer Name</label>
                    <p className='f-12'>{customer.name}</p>
                </div>}
                <div className="form-group">
                    <label className="f-12">Relationship Manager</label>
                    {adminList ? <Autocomplete
                        className="f-12"
                        id="companyIP"
                        value={relationshipManager ? relationshipManager : ""}
                        placeholder="Manager Name"
                        getOptionLabel={option => option.name}
                        onChange={handleRMChange}
                        options={adminList}
                        renderInput={(params) => <TextField {...params} placeholder="Manager Name" className="f-12" />}
                    /> : null}
                </div>
                <div className="form-group">
                    <label className="f-12">Company Name</label>
                    {companyList ? <Autocomplete
                        className="f-12"
                        id="companyIP"
                        value={comapnyId ? comapnyId : ""}
                        placeholder="Company Name"
                        getOptionLabel={option => option.name}
                        onChange={handleCompanyChange}
                        options={companyList}
                        renderInput={(params) => <TextField {...params} placeholder="Company Name" className="f-12" />}
                    /> : null}
                </div>
                <div className="form-group">
                    <label className="f-12">Call Remarks</label>
                    <textarea id="roleName" className="form-control f-10" placeholder="Call Remarks" value={remark} required onChange={(e) => {
                        setRemark(e.target.value)
                    }} />
                </div><div className="form-group">
                    <label className="f-12">Cx Segment</label>
                    <select id="cx_segment" className="form-control f-10" placeholder="Cx Segment" value={custSegment} onChange={(e) => {
                        setCustSegment(e.target.value)
                    }} >
                        <option value="" disabled>---Select an option---</option>
                        <option value="Low">Low</option>
                        <option value="Mid">Mid</option>
                        <option value="High"> High</option>
                    </select>
                </div>
                <div className="form-group">
                    <label className="f-12">Follow up Date</label>
                    <input type="date" id="newsDate" className="form-control f-10" placeholder="Last call Date" value={followUpDate} required onChange={(e) => {
                        setFollowUpDate(e.target.value)
                    }} />
                </div>
                <div className="form-group">
                    <label className="f-12">Interested in</label>
                    <select id="roleName" className="form-control f-10" placeholder="Interested in" value={interested_in} onChange={(e) => {
                        setInterested_in(e.target.value)
                    }} >
                        <option value="" disabled>---Select an option---</option>
                        <option value="Startups">Startups</option>
                        <option value="Large Cap">Large Cap</option>
                        <option value="Fixed Income"> Fixed Income</option>
                    </select>
                </div>
            </form>
            <div className="form-check p-0">
                <p className="text-danger" id="createRoleError">{error}</p>
            </div>
            <div className='row m-0 p-0'>
                <div className='col-9 m-0 p-0'>
                    <button id="newsBtn" className="btn btn-primary f-12" onClick={(e) => {
                        e.preventDefault()
                        addRemark()
                    }}>{editRemark ? "Update Remark" : "Add Remark"}</button>
                    <div id="newsBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                </div>
                <div className='col-3 m-0 p-0'>
                    <button className="btn btn-primary f-12" onClick={(e) => {
                        e.preventDefault()
                        resetValues()
                    }}>Reset</button>
                </div>
            </div>
            <div className='row m-0 p-0'>
                <button className="btn btn-primary mt-3 d-md-none" onClick={(e) => {
                    e.preventDefault()
                    document.getElementById("rmCreateNews").classList.toggle('d-none')
                    document.getElementById("newsListPage").classList.toggle('d-none')
                    history.push('/crm')
                }}>View User Remarks    </button>
            </div>
            <form id="crmBulkFileForm">
                <div className="form-group mt-5">
                    <p className="h6 text-custom-grey">Bulk Upload User Insights</p>
                    <div className="file-border rounded py-4" onDragOver={(e) => {
                        e.preventDefault();
                    }} onDrop={(e) => {
                        uploadFile(e.dataTransfer.files[0])
                        e.preventDefault();
                    }}>
                        <i className="fas fa-file-upload f-22"></i>
                        <p className="pb-0 mb-0 f-12">
                            Drag your file or &nbsp;
                            <input type="file" id="upload_userInsight" required hidden accept=".csv, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => {
                                uploadFile(e.target.files[0])
                                e.target.value = '';
                            }} />
                            <label htmlFor="upload_userInsight" className="mb-0 pb-0">Click here</label>
                            &nbsp; to choose <br /> Upload: <span className="text-theme">{file ? file.name : ""}</span>
                        </p>
                    </div>
                </div>
                <div className="form-check p-0">
                    {errorDetail ? <p className="text-danger curPoint" id="crmBulkError" onClick={(e) => {
                        e.preventDefault()
                        setShowErrorModal(true)
                    }}>{fileError}</p> : <p className="text-danger" id="crmBulkError">{fileError}</p>}
                </div>
                <div className="text-center">
                    <a id="crmBulkBtn" href="#" className="btn btn-primary f-12" onClick={(e) => {
                        e.preventDefault()
                        uploadFileToServer()
                        document.getElementById("crmBulkFileForm").reset();
                    }}><i className="fas fa-upload mr-2"></i>Upload CSV</a>
                    <div id="crmBulkBtnLoader" className='animBtn d-none'><div className='gSignIn-Anim'></div></div>
                </div>
            </form>

            {/* --------------------------------------------Error Detail Modal-------------------------------------------------------------------- */}
            <Modal open={showErrorModal} onClose={handleClose}>
                <div className="modal-fade" id="KYCSubmitModal" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <h5>Error Detail</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body py-3" style={{ overflowY: "auto", height: "500px" }}>
                                <p className="text-danger">Following errors were found while trying to upload data:</p>
                                <ol>
                                    {errorDetail && Object.keys(errorDetail).map((element, key) => {
                                        if (Array.isArray(errorDetail[element]) && errorDetail[element].length > 0) {
                                            return <li key={`out` + key}>{element}
                                                <ol type='i'>
                                                    {errorDetail[element].map((inner, key) => {
                                                        return <li key={`inner` + key}>{inner}</li>
                                                    })}
                                                </ol>
                                            </li>
                                        } else if (!Array.isArray(errorDetail[element])) {
                                            return <li key={`out` + key}>{element}
                                                <ol type='i'>
                                                    {Object.keys(errorDetail[element]).map((inner, key) => {
                                                        return <li key={`inner` + key}>{inner}
                                                            <ol type='a'>
                                                                {errorDetail[element][inner].map((error, key) => {
                                                                    return <li key={`err` + key}>{error}</li>
                                                                })}
                                                            </ol>
                                                        </li>
                                                    })}
                                                </ol>
                                            </li>
                                        }

                                    })}
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}